// Client wrappers for the briefing + auth flow.

const TRIP_DEFAULT = 'juneau-2026';

async function getJson(url) {
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) throw new Error(`${url} → ${res.status}`);
  return res.json();
}

async function postJson(url, body) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });
  let data;
  try { data = await res.json(); } catch { data = {}; }
  if (!res.ok) {
    const err = new Error(data.message || `${url} → ${res.status}`);
    err.status = res.status;
    err.detail = data;
    throw err;
  }
  return data;
}

export async function fetchBriefing({ tripId = TRIP_DEFAULT, token }) {
  const params = new URLSearchParams({ trip_id: tripId, token });
  return getJson(`/api/briefing/data?${params}`);
}

export async function verifyBriefing({ tripId = TRIP_DEFAULT, token, phrase }) {
  return postJson('/api/auth/verify', {
    trip_id: tripId,
    briefing_token: token,
    phrase,
  });
}

export async function fetchSession({ tripId = TRIP_DEFAULT } = {}) {
  const params = new URLSearchParams({ trip_id: tripId });
  return getJson(`/api/auth/session?${params}`);
}
